// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackagesStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DesignPackagesStepQuery = { __typename?: 'Query', designPackages: { __typename?: 'DesignPackagesPageResult', entities: Array<{ __typename?: 'DesignPackage', id: string, name: string, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, planPackages: Array<{ __typename?: 'PlanPackage', id: string }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, forDesignExterior: boolean, forDesignInterior: boolean, name: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> } };

export type DesignPackage_DesignPackagesStepFragment = { __typename?: 'DesignPackage', id: string, name: string, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, planPackages: Array<{ __typename?: 'PlanPackage', id: string }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, forDesignExterior: boolean, forDesignInterior: boolean, name: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> };

export const DesignPackage_DesignPackagesStepFragmentDoc = gql`
    fragment DesignPackage_DesignPackagesStep on DesignPackage {
  id
  name
  location {
    code
  }
  planPackages {
    id
  }
  optionGroups {
    id
    forDesignExterior
    forDesignInterior
    name
    order
    options {
      id
    }
  }
}
    `;
export const DesignPackagesStepDocument = gql`
    query DesignPackagesStep {
  designPackages(filter: {status: [ACTIVE]}) {
    entities {
      ...DesignPackage_DesignPackagesStep
    }
  }
}
    ${DesignPackage_DesignPackagesStepFragmentDoc}`;

/**
 * __useDesignPackagesStepQuery__
 *
 * To run a query within a React component, call `useDesignPackagesStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackagesStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackagesStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignPackagesStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>(DesignPackagesStepDocument, options);
      }
export function useDesignPackagesStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>(DesignPackagesStepDocument, options);
        }
export function useDesignPackagesStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>(DesignPackagesStepDocument, options);
        }
export type DesignPackagesStepQueryHookResult = ReturnType<typeof useDesignPackagesStepQuery>;
export type DesignPackagesStepLazyQueryHookResult = ReturnType<typeof useDesignPackagesStepLazyQuery>;
export type DesignPackagesStepSuspenseQueryHookResult = ReturnType<typeof useDesignPackagesStepSuspenseQuery>;
export type DesignPackagesStepQueryResult = Apollo.QueryResult<DesignPackagesStepQuery, DesignPackagesStepQueryVariables>;